import { ddGlobalSessionId } from '../utils/telemetry';
import { API_BASE } from 'constants/api';
import CookieUtils from '../utils/cookies';
import { fetchHandler } from './utils/fetchHandler';
import { HTTPError } from 'utils/HTTPError';

export const SH_MAGIC_ID_HEADER_KEY = 'x-springhealth-magic-id';

export const generateRequestHeaders = () => ({
  ...CookieUtils.getAuthorizationHeader(),
  [SH_MAGIC_ID_HEADER_KEY]: ddGlobalSessionId.getSessionId(),
  'x-springhealth-client-type': 'Spring Health Admin Portal',
  'Content-Type': 'application/json',
});

const runReportingIntegrationJob = async (integration_id: number, body) => {
  return fetchHandler(`${API_BASE}/reporting_integration_ad_hoc_runs/${integration_id}`, {
    method: 'POST',
    headers: generateRequestHeaders(),
    body: JSON.stringify(body),
  });
};

const submitCensus = async (body) => {
  /**
   * The form that uses this API uses the FormData API to grab form data. As such, the content-type
   * can/should be omitted to allow the browser to set it automatically.
   */
  const { 'Content-Type': _, ...headers } = generateRequestHeaders();

  const response = await fetchHandler(`${API_BASE}/census_ingestions`, {
    method: 'POST',
    headers,
    body,
  });

  return response.json();
};

const submitBulkMemberCharges = async (csvFile: File) => {
  const formData = new FormData();
  formData.append('csv_file', csvFile);
  const { 'Content-Type': _, ...headers } = generateRequestHeaders();

  try {
    const response = await fetchHandler(`${API_BASE}/bulk_charge_runs`, {
      method: 'POST',
      headers,
      body: formData,
    });
    return response.json();
  } catch (e) {
    if (e instanceof HTTPError && e.response.status === 422) {
      return e.response.json();
    }
    throw e;
  }
};

const downloadBulkChargeRunCsv = async (bulkChargeRunId: string): Promise<Response> => {
  const { 'Content-Type': _, ...headers } = generateRequestHeaders();
  return fetchHandler(`${API_BASE}/bulk_charge_runs/${bulkChargeRunId}.csv`, {
    method: 'GET',
    headers: { ...headers, Accept: 'text/csv' },
  });
};

export default {
  generateRequestHeaders,
  runReportingIntegrationJob,
  submitCensus,
  submitBulkMemberCharges,
  downloadBulkChargeRunCsv,
};
